import { getSignatureFields } from "./get-signature-fields";

export const renderBehavioralData = (note) => {
  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Patient Report or Behavior</label>
          <p>{note.patient_report}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Interventions</label>
          <p>{note.interventions}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Intervention Reaction</label>
          <p>{note.intervention_reaction}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Patient Task</label>
          <p>{note.patient_task}</p>
        </div>
      </div>

      {getSignatureFields(note)}
    </div>
  );
};
